

























import Vue from 'vue'
import ExerciseReportTable from '@/components/exercises/components/ExerciseReportTable.vue'
import ExerciseReportHead from '@/components/exercises/components/ExerciseReportHead.vue'
import ExerciseDialog from '@/components/exercises/components/ExerciseDialog.vue'
import { ActionNames } from '@/store/modules/exercise/keys'
import { mapActions } from 'vuex'
import { ModuleNames } from '@/store/module-names'

export default Vue.extend({
  components: {
    ExerciseReportTable,
    ExerciseReportHead,
    ExerciseDialog,
  },
  props: {
    exercises: {
      type: Array,
      default: () => [],
    },
    patientId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isOpenDialog: false,
      isDeleting: false,
      deletionCandidateId: null,
    }
  },
  computed: {
    dialogTitle() {
      const candidateExercise = this.exercises.find(exercise => exercise.id === this.deletionCandidateId)
      return candidateExercise ? `Delete an Exercise Data (${candidateExercise.exerciseDate})` : ''
    },
  },
  methods: {
    ...mapActions(ModuleNames.exercise, [ActionNames.deleteExercise]),
    openDialog(id) {
      this.isOpenDialog = true
      this.deletionCandidateId = id
    },
    async deleteExercise(): Promise<void> {
      this.isDeleting = true
      await this[ActionNames.deleteExercise]({
        exerciseId: this.deletionCandidateId,
        patientId: this.patientId,
      })
      this.isDeleting = false
      this.isOpenDialog = false
      this.deletionCandidateId = ''
    },
  },
})
